import { Link } from "react-router-dom";

export function AboutPage() {
  return (
    <main className="about-page">
      <section className="about-hero">
        <p className="about-eyebrow">Austin new construction, made more visible</p>
        <h1>See Austin’s new homes earlier.</h1>
        <p>
          New construction homes do not always appear on public home-search sites such as Zillow and Redfin while they are being built. Austin Home Permits helps buyers discover eligible new-build homes in progress through public permit activity.
        </p>
        <Link className="button primary" to="/">Explore permit activity</Link>
      </section>

      <section className="about-grid" aria-label="How Austin Home Permits works">
        <article className="about-card">
          <h2>New-build visibility</h2>
          <p>We organize residential permits so buyers can explore where new homes are taking shape—before they may be broadly marketed.</p>
        </article>
        <article className="about-card">
          <h2>Estimated completion</h2>
          <p>We use historical permit data to model a likely completion window. It is an estimate, not a construction schedule or a promise of availability.</p>
        </article>
        <article className="about-card">
          <h2>Plan-based imagery</h2>
          <p>When permit plans are available, AI-assisted imaging can help imagine what a completed home may look like. These images are illustrative, not official renderings.</p>
        </article>
      </section>

      <section className="about-note" aria-label="Important information">
        <p><strong>Permit activity is not a verified listing or offer for sale.</strong> Details can change as permits are revised and construction progresses.</p>
        <p><strong>*</strong> For the most accurate renderings, pricing, availability, and purchase information, visit the builder’s website and confirm directly with the builder.</p>
      </section>
    </main>
  );
}
